import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal"
import luckyWinnerCampaignModel from "@/models/lucky-winner/lucky-winner-campaign"
import router from "@/router"
import store from "@/store"
import useFlatPickr from "@/utils/hooks/useFlatPickr"
import { onBeforeMount, reactive, ref } from "@vue/composition-api"

export default function useRoundInfo() {
  const {
    createCampaign, 
    fetchCampaignList, 
    fetchCampaignDetail, 
    editCampaign, 
    setCampaignStatus
  } = luckyWinnerCampaignModel()
  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal()

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const campaignInfoData = reactive({
    seq: 0,
    name: "",
    startdate: "",
    enddate: "",
    status: false
  })

  const isEdit = ref(false)

  const fetchCampaignInfoFunc = () => {
    window.$loading(true)
    fetchCampaignDetail.payload.CampaignId = campaignInfoData.seq

    store
      .dispatch('api/apiRequest', fetchCampaignDetail)
      .then(response => {
        const respData = response.data.resp
        if (Object.keys(respData).length > 0) {
          campaignInfoData.seq = respData.id
          campaignInfoData.name = respData.campaign_name
          validFrom.date = resolveDate(respData.startdate)
          validFrom.time = resolveTime(respData.startdate)
          validThrough.date = resolveDate(respData.enddate)
          validThrough.time = resolveTime(respData.enddate)
          campaignInfoData.status = respData.status
        }
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const checkFormCreateOrEdit = () => {
    isEdit.value = false
    if (router.currentRoute.params.campaignId) {
      isEdit.value = true
      campaignInfoData.seq = router.currentRoute.params.campaignId
    }
  }

  const onSubmitForm = () => {
    window.$loading(true)
    const payload = {
      name: "",
      Startdate: "",
      Starttime: "",
      Enddate: "",
      Endtime: "",
      Status: false
    }

    createCampaign.payload = payload
    editCampaign.payload = payload

    let payloadParam = {}
    if (isEdit.value == true) {
      payloadParam = editCampaign
      payloadParam.payload.Id = campaignInfoData.seq
      payloadParam.payload.name = campaignInfoData.name
      payloadParam.payload.Startdate = validFrom.date
      payloadParam.payload.Starttime = validFrom.time
      payloadParam.payload.Enddate = validThrough.date
      payloadParam.payload.Endtime = validThrough.time
      payloadParam.payload.Status = campaignInfoData.status
    } else {
      payloadParam = createCampaign
      payloadParam.payload.name = campaignInfoData.name
      payloadParam.payload.Startdate = validFrom.date
      payloadParam.payload.Starttime = validFrom.time
      payloadParam.payload.Enddate = validThrough.date
      payloadParam.payload.Endtime = validThrough.time
      payloadParam.payload.Status = campaignInfoData.status
    }
    store
      .dispatch('api/apiRequest', payloadParam)
      .then(response => {
        if (response.status == "success") {
          openSuccessModal('ทำรายการสำเร็จ !', null, null, null, () => {
            router.replace(`/lucky-winner/campaign/list`)
          })
        }
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  onBeforeMount(() => {
    checkFormCreateOrEdit()
    if (campaignInfoData.seq) {
      fetchCampaignInfoFunc()
    }
  })

  return {
    campaignInfoData,
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    onSubmitForm,
  }
}
